import React from 'react';
import { useCurrentFrame, useVideoConfig, spring, interpolate } from 'remotion';

export const SplitText: React.FC<{
  text: string;
  delay?: number;
  staggerFrames?: number;
  type?: 'chars' | 'words' | 'lines';
}> = ({ text, delay = 0, staggerFrames = 2, type = 'chars' }) => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();

  let elements: string[] = [];
  if (type === 'chars') {
    elements = text.split('');
  } else if (type === 'words') {
    elements = text.split(' ');
  } else {
    elements = text.split('\n');
  }

  return (
    <div style={{ display: 'inline-flex', flexWrap: 'wrap', gap: type === 'words' ? '0.25em' : '0' }}>
      {elements.map((el, i) => {
        // Support spaces when splitting by char
        if (type === 'chars' && el === ' ') {
          return <span key={i} style={{ display: 'inline-block', width: '0.25em' }}>&nbsp;</span>;
        }

        const itemDelay = delay + i * staggerFrames;
        
        // Use a smooth spring for each element
        const progress = spring({
          frame: frame - itemDelay,
          fps,
          config: {
            damping: 14,
            stiffness: 90,
          },
        });

        // Cinematic Fade Up + Micro Scale
        const opacity = interpolate(progress, [0, 1], [0, 1], { extrapolateRight: 'clamp' });
        const translateY = interpolate(progress, [0, 1], [15, 0], { extrapolateRight: 'clamp' });
        const scale = interpolate(progress, [0, 1], [0.96, 1], { extrapolateRight: 'clamp' });
        const blur = interpolate(progress, [0, 1], [10, 0], { extrapolateRight: 'clamp' });

        return (
          <span
            key={i}
            style={{
              display: 'inline-block',
              opacity,
              filter: `blur(${blur}px)`,
              transform: `translateY(${translateY}px) scale(${scale})`,
            }}
          >
            {el}
          </span>
        );
      })}
    </div>
  );
};

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
